export default __webpack_public_path__ + "static/media/linkedin.9134213f.svg";